import React from 'react'
import { useGlobalStyles } from '~shared/styles/globalStyles'
import { useTranslation } from 'react-i18next'
import Col from '~shared/components/MuiGrid/Col'
import { Button, Typography } from '@mui/material'
import Row from '~shared/components/MuiGrid/Row'
import { useDispatch } from 'react-redux'
import { resetForm } from '~store/wizardSpareAxleRequest/actions'
import clsx from 'clsx'

export const Success: React.FC = () => {
  const gs = useGlobalStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  return <>
    <Row spacingTop={3}>
      <Col>
        <Typography variant='h4' component='h1' style={{ marginBottom: '1rem' }} color='secondary'>
          {t('form:spareAxleRequestFormStepSuccessHeading')}
        </Typography>
        <Typography className={gs.marginBottomSmall}>
          {t('form:spareAxleRequestFormStepSuccessText')}
        </Typography>
        <Button
          variant='contained'
          color='secondary'
          className={clsx(gs.marginTopSmall, gs.marginBottomSmall, gs.roundCornersTop, gs.roundCornersBottom)}
          onClick={() => dispatch(resetForm())}
          style={{ color: '#FFFFFF' }}
        >
          {t('form:spareAxleRequestFormStepSuccessButton')}
        </Button>
      </Col>
    </Row>
  </>
}

export default Success
